var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M74.81 51.316c-4.238-4.238-7.588-9.39-7.588-15.383v-8.141a26.667 26.667 0 1 0-53.333 0v8.141c0 5.993-3.35 11.145-7.587 15.383a4.445 4.445 0 0 0 3.142 7.587h62.223a4.445 4.445 0 0 0 3.142-7.587Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.25 80.5c2.65.002 5.254-.69 7.55-2.007A15.05 15.05 0 0 0 54.325 73a4.98 4.98 0 0 0 0-5 5 5 0 0 0-1.84-1.83 5.05 5.05 0 0 0-2.515-.67H32.529c-.883 0-1.75.231-2.514.67A5 5 0 0 0 28.174 68a4.98 4.98 0 0 0 0 5 15.05 15.05 0 0 0 5.527 5.493A15.16 15.16 0 0 0 41.25 80.5",
    opacity: 0.4
  })));
};
export default SvgAlert;